export const ThemeColor = {
  config: {
    initialColorMode: 'dark',
  }
}